import { render } from "./studentReview.vue?vue&type=template&id=9971bba6&scoped=true"
import script from "./studentReview.vue?vue&type=script&lang=js"
export * from "./studentReview.vue?vue&type=script&lang=js"

import "./studentReview.vue?vue&type=style&index=0&id=9971bba6&lang=scss&scoped=true"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9971bba6"]])

export default __exports__